import { ARTICLE_PAGE_TEST_IDS } from 'constants/testsIds/articlePage';
import { useState } from 'react';
import Link from 'components/Globals/Base/Link';
import useBreakpoint from 'hooks/useBreakpoint';
import * as S from './JumpToStyles';

export interface JumpToProps {
  contents: {
    name: string;
    rank: number;
  }[];
  className: string;
  headerHeight: number;
}

const JumpTo = ({ contents, className, headerHeight }: JumpToProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const isTabletAndMobile = useBreakpoint('lgMax');

  const handleItemClick = () => {
    if (isTabletAndMobile) setDropdownOpen(!dropdownOpen);
  };

  return (
    <S.Wrapper
      data-cy={ARTICLE_PAGE_TEST_IDS.JUMPTO}
      className={className}
      $headerHeight={headerHeight}
    >
      <S.Title
        onClick={() => setDropdownOpen(!dropdownOpen)}
        $dropdownOpened={dropdownOpen}
      >
        Jump To
      </S.Title>
      <S.ContentWrapper $dropdownOpened={dropdownOpen}>
        {contents.map((item) => (
          <Link
            href={`#${item.rank}`}
            key={item.rank}
            onClick={() => handleItemClick()}
          >
            <S.Item>{`${item.name} (#${item.rank})`}</S.Item>
          </Link>
        ))}
      </S.ContentWrapper>
    </S.Wrapper>
  );
};

export default JumpTo;
